// Stateless date helpers shared by the API server and the web client.
// Kept tiny on purpose — no Intl, no date-fns, just YYYY-MM-DD ↔ UTC ms.

const DAY_MS = 86_400_000;

export function parseYMDToUTC(ymd: string): number {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd);
  if (!m) return Number.NaN;
  return Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

export function formatYMD(utcMs: number): string {
  const d = new Date(utcMs);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Night dates for a stay with [check_in, check_out): includes check_in,
 * excludes check_out. So 2026-07-15 → 2026-07-18 yields three nights.
 */
export function nightDatesBetween(checkIn: string, checkOut: string): string[] {
  const start = parseYMDToUTC(checkIn);
  const end = parseYMDToUTC(checkOut);
  if (Number.isNaN(start) || Number.isNaN(end) || end <= start) return [];
  const out: string[] = [];
  for (let t = start; t < end; t += DAY_MS) out.push(formatYMD(t));
  return out;
}

/**
 * Day dates for a slot with [check_in, check_out]: inclusive both ends.
 * Used by the per-day duty marker — the warden is at the hut on every
 * calendar day in the range, including the morning of check_out. So
 * 2026-07-15 → 2026-07-18 yields four days.
 */
export function dayDatesInclusive(checkIn: string, checkOut: string): string[] {
  const nights = nightDatesBetween(checkIn, checkOut);
  return nights.length === 0 ? [] : [...nights, checkOut];
}
